module.exports = __webpack_public_path__ + "img/hero-vanguards-le_woodsy.ee715a8.jpg";